import GetInTouch from './GetInTouch/GetInTouch';
import Map from './Map/Map';
import { Helmet } from 'react-helmet-async';

function Contact() {
    return (
        <div>
            <Helmet><title>Contact | Phoenix Object Conservation</title></Helmet>
            <GetInTouch />
            <Map />
        </div>
    );
}

export default Contact;